import { Link } from "react-router-dom";
import { blogPosts } from "../../../mocks/blogPosts";

export default function FeaturedPost() {
  const post = blogPosts[0];

  return (
    <Link to={`/blog/${post.id}`} className="group block">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 bg-white overflow-hidden rounded-sm border border-black/8">
        {/* Image */}
        <div className="relative w-full h-72 lg:h-auto overflow-hidden bg-[#e8e8e8]">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-black/10" />
          <div className="absolute top-5 left-5">
            <span
              className="bg-black text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 font-bold"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Featured
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-10 lg:p-14 flex flex-col justify-center">
          <span
            className="text-black/40 text-[10px] tracking-[0.3em] uppercase mb-4 block"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            {post.category}
          </span>
          <h2
            className="text-black font-black text-3xl lg:text-4xl leading-tight mb-5 group-hover:opacity-70 transition-opacity duration-200"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            {post.title.toUpperCase()}
          </h2>
          <p
            className="text-black/50 text-sm leading-relaxed mb-8"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            {post.excerpt}
          </p>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <span className="text-black/40 text-xs" style={{ fontFamily: "'Barlow', sans-serif" }}>{post.date}</span>
              <span className="w-1 h-1 bg-black/20 rounded-full" />
              <span className="text-black/40 text-xs" style={{ fontFamily: "'Barlow', sans-serif" }}>{post.readTime}</span>
            </div>
            <div className="flex-1" />
            <span
              className="text-black text-xs font-bold tracking-[0.15em] uppercase flex items-center gap-2"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Read Story
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200"></i>
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
